import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: "O campo {_field_} é obrigatório!"
})



// WEBPACK FOOTER //
// ./src/helpers/validation.js